import { useTranslation } from "react-i18next"
import { MainContentPaddingTypes, NewModal } from "../Components"
import { frames, fonts, colors } from "../Styles"
import { hardNavigateToLogin } from '../Navigation/root'

export default function Error50X() {
  const {t} = useTranslation()

  return (
    <frames.DecorBg>
      <NewModal
        modalState
        predefinedButtons={{
          onGoBack: () => hardNavigateToLogin()
        }}
        overrides={{
          mainContentPadding: MainContentPaddingTypes.secondary,
          overlayColor: colors.blackPrimary+"99"
        }}
        header={t("error.50x.header", {defaultValue: "Selected Domain Unreachable"})}
        mainContent={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
            <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary }}>{t("error.50x.content", {defaultValue: "The domain wasn't reachable by the cloud server."})}</p>
            <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary }}>{t("error.50x.subContent", {defaultValue: "Either the local server is offline or the server is without internet"})}</p>
          </div>
        }/>
    </frames.DecorBg>
  );
}